export const acceptedImages = [
    ".jpeg",
    ".jpg",
    ".png",
    ".gif",
    ".heic",
    ".dng",
    ".webp",
]
export const acceptedVideos = [
    ".avi",
    ".mkv",
    ".mov",
    ".mp4",
    ".webm",
]